import {Component, Injector} from "@angular/core";
import {
    AbstractSingleSelectEditControlComponent
} from "../../framework/entity/edit/edit-controls/select-edit-controls/abstract-single-select-edit-control.component";
import {
    registerSelectEditControl
} from "../../framework/entity/edit/edit-controls/select-edit-controls/abstract-select-edit-control.component";

@Component({
    selector: "wbo-day-of-week-single-select-edit-control",
    templateUrl: "../../framework/entity/edit/edit-controls/select-edit-controls/single-select-edit-control.component.html",
    providers: [
        registerSelectEditControl(DayOfWeekSingleSelectEditControl),
    ]
})
export class DayOfWeekSingleSelectEditControl extends AbstractSingleSelectEditControlComponent<any> {
    constructor(injector: Injector) {
        super(undefined, injector);

        this.buildData([
            {label: "wbo.common.dayOfWeek.monday", value: "1"},
            {label: "wbo.common.dayOfWeek.tuesday", value: "2"},
            {label: "wbo.common.dayOfWeek.wednesday", value: "3"},
            {label: "wbo.common.dayOfWeek.thursday", value: "4"},
            {label: "wbo.common.dayOfWeek.friday", value: "5"},
            {label: "wbo.common.dayOfWeek.saturday", value: "6"},
            {label: "wbo.common.dayOfWeek.sunday", value: "7"}
        ]);
    }
}
